export const ALL = "ALL";
export const DRAFT = "DRAFT";
export const SENT = "SENT";
export const DECLINED = "DECLINED";
export const ACCEPTED = "ACCEPTED";
export const INVOICED = "INVOICED";
